import React, { useEffect } from "react"
import { ReactNode } from "react"
import { useGa4Context } from "../../context/Ga4Context"

type ga4FormProps = {
  formName: string
  children: ReactNode
}
export const Ga4Form = (props: ga4FormProps) => {
  const ga4Context = useGa4Context()
  useEffect(() => {
    ga4Context.setFormName(props.formName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.formName])

  return (<>{props.children}</>)
}


